/**
 * Talent functions (Funktion) offered in the talent forms. One list for Add Talent, the inline
 * edit on the talent list and the suggestions on the talent edit page, so a new function only
 * has to be added here. "Copywriting" was added 2026-09-20 for the Copywrite orders.
 */
export const TALENT_FUNCTIONS = [
  'Hair & Make-Up',
  'Art Direktion',
  'Foto',
  'Foto Assist',
  'Video',
  'Digi-OP',
  'Styling',
  'Styling Assist',
  'LOGISTIK / WARENAUFBEREITUNG',
  'PRODUCER',
  'Art Buying',
  'Account Management',
  'Videoproducing',
  'AI Content Production',
  'Development',
  'Post Production',
  '3D Artist',
  'Marketing I Sales 70440',
  'Copywriting',
];

/** react-select shaped options for the same list. */
export const TALENT_FUNCTION_OPTIONS = TALENT_FUNCTIONS.map((f) => ({ value: f, label: f }));
